"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openNewTab = exports.navigateTo = void 0;

var navigateTo = function navigateTo(url) {
  window.location.href = url;
};

exports.navigateTo = navigateTo;

var openNewTab = function openNewTab(url) {
  window.open(url, '_blank');
};

exports.openNewTab = openNewTab;